import React from "react"

import useLazyImport from "hooks/useLazyImport"

import Icon from "icons"

const TestimonialGallery = ({ elRef, testimonials, dataId, hideOnPageLoad, ...props }) => {
  const styles = useLazyImport(() => import("./styles"))
  if (!styles) return null

  const { Slider, Slide, Container, Prev, Next, Dots } = styles

  return (
    <section data-exp-id={dataId} ref={elRef} {...props}>
      <Container
        hideOnPageLoad={hideOnPageLoad}
        totalSlides={testimonials.length}
        naturalSlideWidth={1}
        naturalSlideHeight={1}
        infinite
      >
        <Slider>
          {testimonials.map((t, index) => (
            <Slide key={t.key} index={index}>
              {t}
            </Slide>
          ))}
        </Slider>
        <Prev>
          <Icon id="play-icon-filled" width={50} />
        </Prev>
        <Next>
          <Icon id="play-icon-filled" width={50} />
        </Next>
        <Dots />
      </Container>
    </section>
  )
}

export default TestimonialGallery
